module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I have always considered myself a pragmatist, which has served me well as both a cowboy and a cattleman. I’ve heard it said that the opposite of love does not express itself as hate, but as indifference. If that is so, then the obverse of loyalty and duty is not manifested by faithlessness, but apathy. As the sheriff of Meriwether County, I have seen this to be true.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The story of Cronos—the father of the gods who gave his name to time itself—has its origins in ancient mythology. He ascended to the throne by murdering his father, thereafter taking his own sister as his wife, and siring half a dozen children with her. His fear of familial treachery, however, was so acute that he massacred all six of the daughters and sons he had fathered and consummated the deed by devouring their remains. So while our present generation had clearly not originated the notions of degeneracy, solipsism, greed, sloth, lust, or envy, it seemed to be increasingly dedicated to the perfection of their practice.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had been raised in simpler times, taking pride in the cattle we produced on the family ranch, which itself had been assembled from the sweat and blood and sacrifice of three generations. But the tenuous threads that held the world together back when I’d returned home from my service in Korea had been tested to their breaking point since the dawning of Aquarius.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What had spontaneously begun as a summer of love in 1967 had been corrupted in its infancy by the perverse and senseless acts of violence provoked by an aspiring musician and self-proclaimed messiah named Charles Manson just two short years after it had begun, and was ultimately nailed to a cross of its own construction during a rock concert at a California speedway four short months later, in December of that very same year.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As had become our personal tradition, my wife, Jesse, and I acknowledged the arrival of the New Year by watching the ball drop in Times Square from the safe distance afforded by the television console in the living room at the ranch house. We sipped iced champagne from the same etched crystal flutes that we had used to toast our wedding vows more than twenty years before, hoping as we always did that the upcoming year would be an improvement on the last.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("On this night, however, I wondered how things could get much worse. But I kept that misanthropic notion to myself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("1974 had been one of the most demoralizing that I could remember.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The nation had endured the humiliation of Watergate and the resignation of a sitting president, who was subsequently succeeded by a man named Gerald R. Ford. In assuming his role as our thirty-eighth president, Ford became the only man to assume that high office by political appointment; he had replaced the disgraced Spiro Agnew as vice president, who himself had pleaded no contest to federal income tax evasion in exchange for the dropping of charges of political corruption.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But that was only the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The long, slow withdrawal of troops that marked our defeat in Vietnam had not only cost the lives of tens of thousands of United States soldiers, but was made all the worse by welcoming the survivors home with antipathy and derision. The Pentagon admitted that at least one-third of returning veterans had used heroin while overseas, and the goal of the typical eighteen-year-old grunt had atrophied to a degree that all he wanted was to simply live to see one more birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Those young people who did return alive faced levels of unemployment not experienced since the Great Depression, rampant double-digit inflation that was forcing businesses to fold, and an international petroleum crisis that quadrupled gasoline prices and forced rationing at the pump. The price of a house had also moved beyond their reach—mortgage interest rates having doubled in a single year—and the traditional bright colored lights of Christmas celebrations had been banned in several states in the name of oil conservation.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As citizens, we had grown not only to distrust our own government officials, but to distrust our neighbors too. Justice Department surveys informed us that one out of every four households in America had suffered a rape, assault, burglary, robbery, or auto theft in the preceding year alone.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The economic abundance that defined the Kennedy and Eisenhower eras had been a byproduct of confidence about our future, but by the end of 1974 the average citizen had lost all faith in an economy managed by poseurs, pundits, and politicians, and We The People learned the meanings of new terms like "), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("stagflation")]), _vm._v(" while we watched Harlem and the Bronx succumb to the flames of arsonists on the nightly news. Such was our assimilation into the dark and hallucinatory vocabulary of an incipient nightmare state.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In response, the disaffected youth who claimed they would no longer tolerate establishment hypocrisy invented a version of hypocrisy that they could call their own. The utopian dream of the overnight elimination of poverty and prejudice and hatred had proven to be a fantasy. But the spark of rebellion that had spawned it remained, and this time there was television and mass media to help shape the Zeitgeist, not as a mirror, but as a tool.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Seemingly overnight, membership in traditional churches declined, only to be replaced by the search for the Self. One of the best-selling books of the year was titled "), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("How to Be Your Own Best Friend.")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Which left me with one nagging question as I shared that cold December evening with my wife: Who manned the rope line between the new world and the old?")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I will freely admit that I have known fear, and that I have witnessed evil in the form and affect of dangerous and misguided elitists who treat the blood, treasure, and sacrifice of their fellow citizens as currency. I had witnessed it firsthand while serving in my war, and I had seen it on the streets, embodied in the actions of edacious and manipulative demagogues who lie outright while they look you in the eye and stake a personal claim upon the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("No, the ones who set my town ablaze, both literally and figuratively, were not insane; I don’t know with any certainty if they were even particularly angry, or bore any personal malice toward the innocents whom they harmed. It was simply something that they felt had to be done.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But what are you supposed to do when someone visits malevolence and brutality upon your life, or worse, inflicts defilement on those you love most? As for me, I will not abide the construction of victims. I am the sheriff of this county.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But I’m getting ahead of myself.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As with all things, it’s best to begin at the beginning.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0af4d3aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504081696-2.vue
// module id = 81
// module chunks = 0